import React from 'react'
import {FormattedDate} from 'react-intl'

import {ContentWrapper} from '@daedalus/atlas/helpers/ContentWrapper'
import {Flex} from '@daedalus/atlas/helpers/Flex'
import {Icon} from '@daedalus/atlas/Icon'
import {Text} from '@daedalus/atlas/Text'
import {dateStringToMiddayDate} from '@daedalus/core/src/utils/date'

import {GuestAndRoomText} from '../GuestAndRoomsText'

export interface Props {
  checkIn?: string
  checkOut?: string
  rooms?: string
  hasCustomStyle?: boolean
}

export const DateAndRoomsText = ({
  checkIn,
  checkOut,
  rooms,
  hasCustomStyle
}: Props) => {
  return (
    <Flex.Row>
      <Flex.Row alignItems="center" gap={hasCustomStyle ? 's250' : 's000'}>
        {hasCustomStyle && (
          <Icon name="Calendar" size="sm" colorPath="content.neutral.c600" />
        )}
        <Text
          variant="bodyS"
          colorPath={
            hasCustomStyle ? 'content.neutral.c950' : 'content.neutral.c600'
          }
          dataId="dates"
        >
          {checkIn && checkOut && (
            <>
              <FormattedDate
                value={dateStringToMiddayDate(checkIn)}
                month="short"
                day="2-digit"
              />
              {' - '}
              <FormattedDate
                value={dateStringToMiddayDate(checkOut)}
                month="short"
                day="2-digit"
              />
            </>
          )}
        </Text>
      </Flex.Row>
      {checkIn && checkOut && rooms && (
        <ContentWrapper paddingX="s250">
          <Text variant="bodyS" colorPath="content.neutral.c600">
            <>{' · '}</>
          </Text>
        </ContentWrapper>
      )}

      {rooms && (
        <Flex.Row alignItems="center" gap={hasCustomStyle ? 's250' : 's000'}>
          {hasCustomStyle && (
            <Icon name="User" colorPath="content.neutral.c600" size="sm" />
          )}
          <Text
            tag="span"
            variant="bodyS"
            colorPath={
              hasCustomStyle ? 'content.neutral.c950' : 'content.neutral.c600'
            }
            dataId="guestsAndRoomsNumber"
          >
            <GuestAndRoomText rooms={rooms} />
          </Text>
        </Flex.Row>
      )}
    </Flex.Row>
  )
}
